export default "__VITE_ASSET__2b6_0LSn__"